module.exports = __webpack_public_path__ + "img/胡黄连.a24cd6ac.jpg";